import React from 'react';
import './Service.css';

import { renderIcon } from '../../utils';

import { Link } from 'react-router-dom';



const Service = ({ service }) => {

  // Destructuring props to extract the necessary details for each service
  const { id, image, title, content } = service;

  return (

    <div className='service-item' key={id}>

      <img src={image} alt={title} />{/* Service Image */}

      <div className='content'>

        <div className='icon'>{renderIcon(title)}</div> {/* Display the service icon based on title */}
        

        <div className='text'>

          {/* Link to the individual service page */}
          <Link
            to={{ 
              pathname: '/Services/' + title,  // Navigate to the specific service page
            }}
            location = {{service}}  // Passing service details to the linked page
            state= {service}> 
            <h3>{title}</h3> {/* Service Title */}
          </Link>

          <p>{content}</p> {/* Service Description */}

          {/* Read more link to navigate to the full service page */}
          <Link
            to={{ 
              pathname: '/Services/' + title,  // Navigate to the specific service page
            }}
            location = {{service}}  // Passing service details to the linked page
            className='btn'  // Apply button style
            state= {service}>Read More
          </Link> 
        
        </div>

      </div>

    </div>

  );
};

export default Service;